import axiosInstance from '../utils/axiosInstance';

const ReminderService = {
  async fetchLabels() {
    try {
      const resp = await axiosInstance.get('/admin/reminders/labels');
      if (Array.isArray(resp?.data?.labels)) {
        return resp.data.labels;
      }
      if (Array.isArray(resp?.data)) {
        return resp.data;
      }
      return [];
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('ReminderService.fetchLabels failed', err);
      return [];
    }
  },

  async createLabel(payload) {
    try {
      const resp = await axiosInstance.post('/admin/reminders/labels', payload);
      if (resp?.data?.label) {
        return resp.data.label;
      }
      return null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('ReminderService.createLabel failed', err);
      throw err;
    }
  },

  async updateLabel(slug, payload) {
    try {
      const safeSlug = encodeURIComponent(slug);
      const resp = await axiosInstance.put(`/admin/reminders/labels/${safeSlug}`, payload);
      if (resp?.data?.label) {
        return resp.data.label;
      }
      return null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('ReminderService.updateLabel failed', err);
      throw err;
    }
  },

  async fetchReminders() {
    try {
      const resp = await axiosInstance.get('/admin/reminders');
      if (Array.isArray(resp?.data?.reminders)) {
        return resp.data.reminders;
      }
      if (Array.isArray(resp?.data)) {
        return resp.data;
      }
      return [];
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('ReminderService.fetchReminders failed', err);
      return [];
    }
  },

  async createReminder(payload) {
    try {
      const resp = await axiosInstance.post('/admin/reminders', payload);
      if (resp?.data?.reminder) {
        return resp.data.reminder;
      }
      return null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('ReminderService.createReminder failed', err);
      throw err;
    }
  },

  async updateReminder(reminderId, payload) {
    try {
      const resp = await axiosInstance.put(`/admin/reminders/${reminderId}`, payload);
      if (resp?.data?.reminder) {
        return resp.data.reminder;
      }
      return null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('ReminderService.updateReminder failed', err);
      throw err;
    }
  },

  async deleteReminder(reminderId) {
    try {
      await axiosInstance.delete(`/admin/reminders/${reminderId}`);
      return true;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('ReminderService.deleteReminder failed', err);
      throw err;
    }
  },
};

export default ReminderService;
